import { Badge } from "@/components/ui/badge";
import { Link as LinkIcon, FileText, StickyNote, Trash2, Loader2 } from "lucide-react";
import { motion } from "framer-motion";

const TYPE_CONFIG = {
  link: { icon: LinkIcon, label: "Link" },
  file: { icon: FileText, label: "File" },
  note: { icon: StickyNote, label: "Note" },
};

export default function SourceCard({ source, onDelete, delay = 0 }) {
  const config = TYPE_CONFIG[source.source_type] || TYPE_CONFIG.note;
  const Icon = config.icon;
  const isProcessing = source.status === "processing";
  const isError = source.status === "error";

  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay }}
      className="group surface-card rounded-xl p-5 border border-border hover:border-border/80 transition-colors"
    >
      <div className="flex items-start gap-3">
        <div className="w-8 h-8 rounded-lg bg-primary/5 flex items-center justify-center shrink-0 mt-0.5">
          {isProcessing ? (
            <Loader2 className="w-4 h-4 text-primary animate-spin" />
          ) : (
            <Icon className="w-4 h-4 text-primary" />
          )}
        </div>

        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-1">
            <h3 className="font-medium text-foreground text-sm truncate">{source.title}</h3>
            <Badge variant="outline" className="text-[10px] shrink-0">{config.label}</Badge>
            {isProcessing && (
              <Badge variant="outline" className="text-[10px] shrink-0 text-amber-600">Processing</Badge>
            )}
            {isError && (
              <Badge variant="outline" className="text-[10px] shrink-0 text-destructive">Error</Badge>
            )}
          </div>

          {source.short_summary && (
            <p className="text-xs text-muted-foreground leading-relaxed line-clamp-2 mb-2">
              {source.short_summary}
            </p>
          )}

          {source.topics?.length > 0 && (
            <div className="flex flex-wrap gap-1">
              {source.topics.slice(0, 5).map((topic, i) => (
                <span key={i} className="text-[10px] px-1.5 py-0.5 rounded-md bg-secondary text-muted-foreground">
                  {topic}
                </span>
              ))}
            </div>
          )}
        </div>

        {onDelete && (
          <button
            onClick={() => onDelete(source.source_id)}
            className="p-1.5 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity hover:bg-destructive/10"
          >
            <Trash2 className="w-3.5 h-3.5 text-destructive/60" />
          </button>
        )}
      </div>
    </motion.div>
  );
}
